import { Link } from 'react-router-dom';
import { LoginArea } from '@/components/auth/LoginArea';

/** phpBB3-style blue gradient site header with logo and login area. */
export function ForumHeader() {
  return (
    <header className="bg-[linear-gradient(to_bottom,#1a6ea3,#105B86)] text-white shadow-md">
      <div className="mx-auto flex max-w-[1100px] items-center justify-between gap-3 px-4 py-4">
        <Link to="/" className="flex items-center gap-3">
          <div className="grid h-10 w-10 place-items-center rounded-md bg-white/15 text-xl font-bold">
            N
          </div>
          <div>
            <div className="text-2xl font-bold leading-none tracking-tight">NostrBoard</div>
            <div className="mt-0.5 text-xs text-white/70">
              A Nostr-powered discussion forum
            </div>
          </div>
        </Link>
        <LoginArea className="max-w-60" />
      </div>
    </header>
  );
}
